import { createApp, shallowRef } from "vue";
import { icon, Marker, marker } from "leaflet";

import { currentLocation, currentOpenedPopup, leafletElement } from ".";
import { courierData } from "~/client/elements/repository";

import Popup from "@/components/Popup.vue";

export const markers = shallowRef<Marker<unknown>[]>([]);

export async function openMarkerPopupById(locationId: string) {
	const marker = markers.value.find((m: any) => {
		const contentId = JSON.parse(m._popup.getContent().dataset.id).id;
		return currentLocation.value?.id === contentId;
	});

	if (marker) {
		currentOpenedPopup.value?.close();
		marker.openPopup();
		leafletElement.value?.panTo(marker.getLatLng());
		currentOpenedPopup.value = marker.getPopup();
	}
}

export function addMarkers() {
	if (!courierData.value || courierData.value.length === 0) {
		console.error("No courier data available for markers.");
		return;
	}

	if (!leafletElement.value) return;

	if (markers.value && markers.value.length > 0) {
		markers.value?.forEach((mark) => mark?.remove());
		markers.value = [];
	}

	markers.value = courierData.value?.flatMap((courier) =>
		courier?.locations
			?.map((location) => {
				const customIcon = icon({
					iconUrl: courier.courier.images.mark,
					iconSize: [28, 28],
					iconAnchor: [14, 28],
					popupAnchor: [0, -28]
				});

				const mark = marker([location.geo.latitude, location.geo.longitude], {
					icon: customIcon,
					title: location.name,
					riseOnHover: true
				});

				const popupDiv = document.createElement("div");

				popupDiv.dataset.id = JSON.stringify(location);
				popupDiv.dataset.icon = courier.courier.images.mark;
				popupDiv.dataset.courier = courier.courier.name;

				const popupApp = createApp(Popup, {
					location,
					icon: courier.courier.images.mark,
					courier: courier.courier.name
				});

				popupApp.mount(popupDiv);

				mark.bindPopup(popupDiv);
				mark.addTo(leafletElement.value as any);

				return mark;
			})
			.filter((mark) => mark !== undefined)
	);
}
